import { render, staticRenderFns } from "./dy-wx-h5.vue?vue&type=template&id=06759ef5&scoped=true&"
import script from "./dy-wx-h5.vue?vue&type=script&lang=js&"
export * from "./dy-wx-h5.vue?vue&type=script&lang=js&"
import style0 from "./dy-wx-h5.vue?vue&type=style&index=0&id=06759ef5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06759ef5",
  null
  
)

export default component.exports